import { Image } from 'expo-image';
import { ErrorBoundaryProps } from 'expo-router';
import * as Updates from 'expo-updates';
import { SafeAreaView } from 'react-native-safe-area-context';

import { Text } from './ui/text';

import { not_found } from '@/assets/images';
import { Button, ButtonText } from '@/components/ui/button';
import { Heading } from '@/components/ui/heading';
import { Sentry } from '@/util/sentry';

export function ErrorBoundary({ error }: ErrorBoundaryProps) {
  Sentry.captureException(error, {
    tags: {
      component: 'ErrorBoundary',
      boundaryType: 'expo-router',
    },
    extra: {
      errorMessage: error?.message,
      errorName: error?.name,
      errorStack: error?.stack,
    },
  });

  return (
    <SafeAreaView className="flex-1 items-center justify-center px-5 py-8" edges={['bottom']}>
      <Image
        alt="not found"
        source={not_found}
        contentFit="contain"
        style={{ height: 257, width: 257, marginBottom: 32 }}
      />
      <Heading size="h1-xl" className="mb-2">
        This screen does not exist
      </Heading>

      {error.message ? <Text className="mb-6 text-center">{error.message}</Text> : null}
      <Button
        className="w-full"
        onPress={() => {
          Updates.reloadAsync();
        }}>
        <ButtonText>Take me home</ButtonText>
      </Button>
    </SafeAreaView>
  );
}
